import React from "react";
import { marqueeWords } from "../mock";

const Marquee = () => {
  const loop = [...marqueeWords, ...marqueeWords, ...marqueeWords, ...marqueeWords];
  return (
    <div
      className="w-full overflow-hidden py-5"
      style={{ background: "var(--cream-3)", borderTop: "1px solid rgba(89,26,32,0.08)", borderBottom: "1px solid rgba(89,26,32,0.08)" }}
    >
      <div className="flex whitespace-nowrap animate-marquee" style={{ width: "max-content" }}>
        {loop.map((w, i) => (
          <div key={`${w}-${i}`} className="flex items-center">
            <span className="font-mono2 px-8" style={{ letterSpacing: "0.22em", fontSize: "0.72rem", color: "var(--wine)" }}>
              {w.toUpperCase()}
            </span>
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: "var(--gold)" }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
